import {TypePolicy} from '@apollo/client/core';

// A poll never moves a PO item back to an older run: awaitProcessSwitchLink decides that per item (VTK-3094).
export const poItemTypePolicy: TypePolicy = {
  fields: {
    tracks: { merge: (_, incoming) => incoming },
    vtk_jobs: { merge: (_, incoming) => incoming },
    // Replaces the removed local resolver for @client field
    format_specific_data_json: {
      read(_, { readField }) {
        const raw = readField('format_specific_data') as string;
        return raw ? JSON.parse(raw) : null;
      }
    },
  },
};
